import { FunctionComponent } from "react";
import {
  StyledIframe,
  StyledImage,
  StyledNumber,
  StyledWrapper,
} from "./image.styles";
import { generateThumbnailUrl, generateUrl } from "./image.utils";

interface ImageProps {
  className?: string;
  publicId: string;
  format?: string;
  number?: number;
  thumbnail?: boolean;
}

const Image: FunctionComponent<ImageProps> = ({
  className,
  publicId,
  format,
  number,
  thumbnail,
}) => {
  if (format === "pdf") {
    return (
      <StyledIframe
        src={generateUrl(publicId)}
        style={{ border: 0, width: "100%" }}
      />
    );
  }

  const url = generateUrl(publicId);
  const thumbnailUrl = generateThumbnailUrl(publicId);

  return (
    <StyledWrapper className={className}>
      <StyledImage src={thumbnail ? thumbnailUrl : url} />
      {number && <StyledNumber>#{number}</StyledNumber>}
    </StyledWrapper>
  );
};

export default Image;
